'use strict';

exports.__esModule = true;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _debounce2 = require('lodash/debounce');

var _debounce3 = _interopRequireDefault(_debounce2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactRouter = require('react-router');

var _mobileMenu = require('./mobile-menu');

var _topNavLinks = require('./top-nav-links');

var _doctifyUtils = require('doctify-utils');

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _defaultMessages = require('../lang/default-messages');

var _defaultMessages2 = _interopRequireDefault(_defaultMessages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_TopNavParameters = require('./top-nav-links').babelPluginFlowReactPropTypes_proptype_TopNavParameters || require('react').PropTypes.any;

var logoPowered = require('../../src/img/logo-powered.svg');

var NavLogo = (0, _reactIntl.injectIntl)(function (_ref) {
  var intl = _ref.intl,
      enableScrollToTop = _ref.enableScrollToTop;
  return _react2.default.createElement(
    _reactRouter.Link,
    { to: '/', className: _style.navbarBrand, onClick: function onClick() {
        return enableScrollToTop();
      } },
    _react2.default.createElement('img', { className: _style.dark, src: logoPowered, title: intl.formatMessage(_defaultMessages2.default.SPECIALIST_FINDER), alt: intl.formatMessage(_defaultMessages2.default.SPECIALIST_FINDER) })
  );
});

var TopNav = function (_React$Component) {
  (0, _inherits3.default)(TopNav, _React$Component);

  function TopNav(props) {
    (0, _classCallCheck3.default)(this, TopNav);

    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));

    var header = null;
    _this.header = header;
    return _this;
  }

  TopNav.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.props.onHeaderResize(this.header && this.header.clientHeight);

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', (0, _debounce3.default)(function () {
        setTimeout(function () {
          return _this2.props.onHeaderResize(_this2.header.clientHeight);
        }, 1000); //timeout because we want to get height after transitions and animations will finish
      }), 500);
    }
  };

  TopNav.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, snapshot) {
    if (!prevProps.app.headerHeight && this.header) {
      prevProps.onHeaderResize(this.header.clientHeight);
    }
  };

  TopNav.prototype.render = function render() {
    var _this3 = this;

    var props = this.props;
    var loggedInClass = props.loggedIn && _style.loggedInTrue;

    var overlay = void 0;
    var header = void 0;

    return _react2.default.createElement(
      'div',
      { className: '' + _style.siteNavWrapper },
      _react2.default.createElement(
        'nav',
        {
          id: '' + _style.SiteNav,
          className: 'navbar-fixed-top ' + loggedInClass + ' ' + (props.className || '') + ' ' + (props.boxShadowOnSearchPage ? _style2.default.removeBoxShadow : _style2.default.addBoxShadow),
          ref: function ref(elem) {
            return _this3.header = elem;
          }
        },
        _react2.default.createElement(NavLogo, { enableScrollToTop: props.enableScrollToTop }),
        _react2.default.createElement(_topNavLinks.TopNavLinks, props),
        _react2.default.createElement(
          'div',
          {
            className: 'visible-xs' },
          _react2.default.createElement(_mobileMenu.MobileMenu, props)
        )
      )
    );
  };

  return TopNav;
}(_react2.default.Component);

// const TopNav = (props: TopNavParameters) => {
//
// };

TopNav.displayName = 'TopNav';

TopNav.defaultProps = {
  loggedIn: false,
  pageName: 'home',
  currentProfile: {},
  availableProfiles: [],
  profileDropdownOpen: false,
  settingsDropdownOpen: false,
  mobileMenuOpen: false,
  boxShadowOnSearchPage: true,
  showAvailableProfiles: true,
  openReviewModal: function openReviewModal() {},
  makeGtmCall: function makeGtmCall() {},
  logOut: function logOut() {},
  openSignUpModal: function openSignUpModal() {},
  toggleProfileDropdown: function toggleProfileDropdown() {},
  toggleSettingsDropdown: function toggleSettingsDropdown() {},
  searchJournal: function searchJournal() {},
  openProfileWizard: function openProfileWizard() {},
  toggleMobileMenu: function toggleMobileMenu() {},
  toggleMobileProfiles: function toggleMobileProfiles() {},
  setCanScrollToTop: function setCanScrollToTop() {},
  closeModal: function closeModal() {
    console.log('closemodal default');
  },
  enableScrollToTop: function enableScrollToTop() {},
  onProfileClicked: function onProfileClicked() {}
};

exports.default = TopNav;


// WEBPACK FOOTER //
// ./components/top-nav/lib/components/top-nav.js